import { render, staticRenderFns } from "./TransactionHistorySVG.vue?vue&type=template&id=28f44829"
import script from "./TransactionHistorySVG.vue?vue&type=script&lang=js"
export * from "./TransactionHistorySVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports